var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.01,2.01C23.45,1.97,1.53,23.76,2.01,50.92c.45,25.73,21.44,47.05,47.89,47.08,26.62.03,48.09-21.42,48.1-47.99.01-26.49-21.45-47.95-47.99-47.99ZM63.26,49.97h-8.63v31h-12.39v-30.84h-6.42v-10.51h6.43c0-1.15-.01-2.2,0-3.25.03-2.42-.03-4.84.15-7.25.19-2.61,1.14-4.96,3.18-6.73,1.93-1.68,4.26-2.53,6.74-2.67,3.86-.21,7.73-.16,11.59-.22.06,0,.12.03.23.06v10.7c-1.27,0-2.52,0-3.78,0-1.19,0-2.37,0-3.55.04-1.24.06-1.99.64-2.05,1.91-.11,2.43-.03,4.87-.03,7.39h9.48c-.32,3.5-.63,6.9-.94,10.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.e9ec1d1590143d890fe038f0d698c022.svg";
export { ForwardRef as ReactComponent };